import { Stack, Typography } from '@mui/material'
import { useTexts } from '../hooks/useTexts'
import { DrivingTime } from './DrivingTime'

export function Level() {
  const texts = useTexts()

  return (
    <Stack gap={1}>
      <Typography variant="body2" color="text.secondary">
        {texts.drivingTime}
      </Typography>
      <DrivingTime fieldName="level" helperText={texts.drivingTimeHelper} />
    </Stack>
  )
}
